import { i18n, localizeBusinessName } from "@dehub/theme";
import type { ILocalizableBusiness } from "@dehub/theme";

/**
 * Business or partner name for display: Cyrillic under the mn locale, the
 * REGISTERED Latin name under en/ko/zh.
 *
 * Never transliterated. A Mongolian company name is usually itself a
 * transliteration of a foreign phrase, so transliterating it back produces a name
 * that belongs to no one: "Эйрвингс Бюро ХХК" would render "Eyrvings Byuro KhKhK"
 * instead of its real registered name, "Airwings Bureau LLC". When no Latin name
 * is stored the Cyrillic name stays on screen in every locale.
 *
 * Accepts any of the three field pairs a business is modelled with across the
 * apps: profileName/profileNameEng, partnerName/partnerNameEng and
 * businessName/businessNameEng.
 */
export const renderBusinessName = (
  business?: ILocalizableBusiness | null,
  fallback = "-"
): string => localizeBusinessName(business, i18n.language, fallback);
